<div class="file-upload-container">
  <!-- Hidden File Input -->
  <input #fileInput type="file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" [attr.multiple]="isMultiple ? true : null"
    (change)="onFilesSelected($event)" hidden />

  <!-- Upload Button -->
  <button class="btn-docs" mat-icon-button (click)="fileInput.click(); $event.preventDefault()" [disabled]="readonly">
    <mat-icon class="mat-icon-custom">attachment</mat-icon>
  </button>

  <!-- Label / File Name Display -->
  <div class="file-name-display">
    <ng-container *ngIf="files.length > 0; else showFileUrlName">
      <mat-label *ngFor="let file of files">{{ file.name }}</mat-label>
    </ng-container>
    <ng-template #showFileUrlName>
      <mat-label *ngIf="fileName; else showLabel">{{ fileName }}</mat-label>
      <ng-template #showLabel>
        <mat-label>{{ labelText }}</mat-label>
      </ng-template>
    </ng-template>
  </div>


  <!-- View Button -->
  <div *ngIf="files.length > 0 || fileBlobUrl  " class="view-btn" style="display: flex; gap: 2px; flex-direction: row;">
    <button *ngIf="previewFileType!=='doc'" mat-stroked-button color="primary" type="button" (click)="togglePreview()"
      class="view">
      {{ showPreview ? 'Close' : 'View' }}
    </button>
    <button mat-stroked-button color="primary" type="button" (click)="downloadFile()" class="view">Download</button>
    <button *ngIf="files.length>0" mat-stroked-button color="primary" type="button" (click)="removeFile()"
      class="remove" aria-label="Remove file" [disabled]="readonly">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

</div>

<!-- Error Display -->
<mat-error *ngIf="control.invalid && control.touched">
  {{ error }}
</mat-error>
<!-- (mousedown)="startPan($event)"
(mousemove)="onPan($event)"
(mouseup)="stopPan()"
(mouseleave)="stopPan()" -->
<!-- display documents -->
<div class="doc-container" *ngIf="showPreview ">
  <div *ngIf="!isLoading">
    <ng-container *ngIf="previewFileType === 'image'">
      <div #wrapper class="image-wrapper" (wheel)="onWheel($event)">
        <img [src]="previewUrl" class="preview-img" [style.transform]="transform" />
      </div>

      <div class="zoom-controls">
        <button [disabled]="scale>=maxScale" [ngClass]="{inactive:scale>=maxScale}" (click)="zoomIn(wrapper)">+ Zoom
          In</button>
        <button [disabled]="scale<=1" [ngClass]="{inactive:scale<=1}" (click)="zoomOut(wrapper)">- Zoom Out</button>
        <button [disabled]="scale<=1" [ngClass]="{inactive:scale<=1}" (click)="resetZoom()">Reset</button>
      </div>
    </ng-container>

    <ng-container *ngIf="previewFileType === 'pdf'">
      <iframe [src]="previewUrl" class="preview-iframe" width="100%" height="600px" frameborder="0">
      </iframe>
    </ng-container>
    <ng-container *ngIf="previewFileType === 'doc'&& files.length<1">
      <iframe [src]="'https://docs.google.com/gview?url='+fileBlobUrl+'&embedded=true'" class="preview-iframe"
        width="100%" height="600px" frameborder="0">
      </iframe>
    </ng-container>
    <ng-container *ngIf="previewFileType === 'doc'&& files.length>0">
      <p>File is not viewable</p>
    </ng-container>

  </div>
  <div *ngIf="isLoading" class="loading">
    <mat-spinner diameter="60" strokeWidth="1"></mat-spinner>
    <span>Please wait, We are Getting the file ready for you...</span>
  </div>
</div>